import { Box, Collapse, Divider, Grid, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import theme from "Theme/AppTheme";
import ConversationsStore from "components/Conversations/Stores/ConversationsStore";
import { Routes } from "components/Navigation/Routes";
import AcxButton from "components/UI/AcxButton";
import AcxLoadingIndicator from "components/UI/AcxLoadingIndicator";
import { observer } from "mobx-react";
import React from "react";
import { useNavigate } from "react-router";
import { useStore } from "utils/useStore";

const PaddingGrid = styled(Grid)(({ theme }) => ({
    padding: theme.spacing(2),
}));

const ConversationEvalCard: React.FunctionComponent<Props> = observer(
    (props) => {
        const navigate = useNavigate();
        const store = useStore(ConversationsStore);

        const canViewScores = store.authStore.canUserView("Module Scores");

        const collapseIn =
            canViewScores &&
            !!store.selectedConversation?.evaluationId &&
            !!store.evaluationScores.length;

        if (
            store.authStore.canUserView("Restrict Evaluations") &&
            !store.authStore.isUserUltra()
        ) {
            return null;
        }
        return (
            <>
                <Divider />
                <Grid>
                    <PaddingGrid item container xs={12}>
                        <Grid item container xs={12}>
                            <Box fontWeight="bold">
                                Evaluation #{props.evaluationNumber}
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Collapse
                                in={canViewScores && store.evalScoresLoading}
                            >
                                <Box sx={{ paddingRight: 5, paddingTop: 1 }}>
                                    <AcxLoadingIndicator
                                        size={40}
                                        alternate="PuffLoader"
                                    />
                                </Box>
                            </Collapse>
                        </Grid>
                        <Grid item xs={12} container>
                            <Collapse in={collapseIn}>
                                <Box sx={{ paddingTop: 1 }}>
                                    {store.evaluationScores.map(
                                        (module, idx) => (
                                            <Grid
                                                item
                                                xs={12}
                                                key={`${idx} ${module.name}`}
                                                sx={{
                                                    padding: theme.spacing(
                                                        0.5,
                                                        0,
                                                    ),
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        fontSize: "14px",
                                                        fontWeight: 400,
                                                    }}
                                                >
                                                    {module.name}
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontSize: "20px",
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    {Number(
                                                        module.moduleScore.toFixed(
                                                            2,
                                                        ),
                                                    )}
                                                </Typography>
                                            </Grid>
                                        ),
                                    )}
                                </Box>
                            </Collapse>
                        </Grid>
                        <Grid
                            item
                            container
                            xs={12}
                            sx={{ paddingTop: 1 }}
                            justifyContent={"center"}
                        >
                            <AcxButton
                                fullWidth
                                id="conversation-eval-card-view-eval-button"
                                color="white"
                                style={{
                                    width: theme.spacing(18),
                                }}
                                onClick={() => {
                                    if (
                                        store.authStore.orgStore
                                            .selectedOrganization?.id &&
                                        props.evaluationId
                                    ) {
                                        navigate(
                                            Routes.makeEvaluationRoute(
                                                store.authStore.orgStore
                                                    .selectedOrganization?.id,
                                                props.evaluationId,
                                            ),
                                        );
                                    }
                                }}
                            >
                                View Evaluation
                            </AcxButton>
                        </Grid>
                    </PaddingGrid>
                </Grid>
            </>
        );
    },
);

export default ConversationEvalCard;

type Props = {
    evaluationId: string;
    evaluationNumber: number;
};
